function maximum(adCodes, countryCode, strFileInfo) {
    let maxMap = {};
    
    try {
        adCodes.forEach((curAdCode) => {
            const adCode = curAdCode.charAt(0) === "/" ? curAdCode : `/${ curAdCode }`;

            // If the ad code or country code cannot be found skip this iteration
            if (strFileInfo[adCode] === undefined || strFileInfo[adCode][countryCode] === undefined) {
                return;
            }

            const impReqDataByAdCodeCountry = strFileInfo[adCode][countryCode];

            // There may be multiple versions i.e. v1, v2, etc... find and return the max for each version
            Object.keys(impReqDataByAdCodeCountry).forEach((key) => {
                const impReqDataByAdCodeCountryVersion = strFileInfo[adCode][countryCode][key];

                if (!Object.prototype.hasOwnProperty.call(maxMap, key)) {
                    maxMap[key] = impReqDataByAdCodeCountryVersion[0] / impReqDataByAdCodeCountryVersion[1];
                } else {
                    maxMap[key]
                        = Math.max(maxMap[key], impReqDataByAdCodeCountryVersion[0] / impReqDataByAdCodeCountryVersion[1]);
                }
            });
        });
    } catch (err) {
        maxMap = {};
    }

    return { values: maxMap };
}

const STR_AGGREGATION_VERSION_TO_FUNCTION_MAP = {
    v1: maximum,
};

export {
    STR_AGGREGATION_VERSION_TO_FUNCTION_MAP,
};
